const u = up.util;
up.LinkCurrentURLs = class LinkCurrentURLs {
    constructor(link) {
        this._isSafe = up.link.isSafe(link);
        if (this._isSafe) {
            const href = link.getAttribute('href');
            if (href && (href !== '#')) {
                this._href = u.matchableURL(href);
            }
            const upHREF = link.getAttribute('up-href');
            if (upHREF) {
                this._upHREF = u.matchableURL(upHREF);
            }
            const alias = link.getAttribute('up-alias');
            if (alias) {
                this._aliasPattern = new up.URLPattern(alias);
            }
        }
    }
    isCurrent(normalizedLocation) {
        if (!normalizedLocation) {
            return false;
        }
        return !!(this._href === normalizedLocation ||
            this._upHREF === normalizedLocation ||
            this._aliasPattern?.test?.(normalizedLocation, false));
    }
    isAnyCurrent(normalizedLocations) {
        return normalizedLocations.some((normalizedLocation) => (this._href === normalizedLocation ||
            this._upHREF === normalizedLocation ||
            this._aliasPattern?.test?.(normalizedLocation, false)));
    }
};
